module.exports = __webpack_public_path__ + "img/border-bottom.d0bfdd71.svg";